<template>
  <!-- 首页/数据概览页面根容器 -->
  <div>
    <!-- 页面标题 -->
    <h3 style="margin-bottom:20px">首页数据概览</h3>

    <!--
      数据卡片行布局
      gutter: 卡片之间的间距
      响应式布局：手机、平板、电脑自动适配
    -->
    <el-row :gutter="15" class="card-row">
      <!-- 今日订单卡片，点击跳转到订单页面 -->
      <el-col :xs="12" :sm="12" :md="6" :lg="6">
        <div class="card-wrapper" @click="goOrder">
          <el-card class="stat-card">
            <div class="label">今日订单</div>
            <div class="num">26</div>
          </el-card>
        </div>
      </el-col>

      <!-- 今日销售额卡片，点击跳转到订单页面 -->
      <el-col :xs="12" :sm="12" :md="6" :lg="6">
        <div class="card-wrapper" @click="goOrder">
          <el-card class="stat-card">
            <div class="label">今日销售额</div>
            <div class="num">¥ 128,600</div>
          </el-card>
        </div>
      </el-col>

      <!-- 总用户数卡片，点击跳转到用户管理 -->
      <el-col :xs="12" :sm="12" :md="6" :lg="6">
        <div class="card-wrapper" @click="goUser">
          <el-card class="stat-card">
            <div class="label">总用户数</div>
            <div class="num">568</div>
          </el-card>
        </div>
      </el-col>

      <!-- 商品总数卡片，点击跳转到商品管理 -->
      <el-col :xs="12" :sm="12" :md="6" :lg="6">
        <div class="card-wrapper" @click="goGoods">
          <el-card class="stat-card">
            <div class="label">商品总数</div>
            <div class="num">126</div>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <!-- 图表区域布局 -->
    <el-row :gutter="15" style="margin-top:20px">
      <!-- 折线图：近七日销售趋势 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <el-card>
          <div id="lineChart" style="width:100%;height:250px;"></div>
        </el-card>
      </el-col>

      <!-- 饼图：商品销量占比 -->
      <el-col :xs="24" :sm="24" :md="12" :lg="12">
        <el-card>
          <div id="pieChart" style="width:100%;height:250px;"></div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// 引入 ECharts 图表库
import * as echarts from 'echarts'

export default {
  // 页面挂载完成后立即执行
  mounted() {
    // 初始化所有图表
    this.initCharts()

    // 监听窗口大小变化，自动重新渲染图表
    window.addEventListener('resize', this.initCharts)
  },

  // 页面销毁前清除事件监听
  beforeDestroy() {
    window.removeEventListener('resize', this.initCharts)
  },

  // 页面方法集合
  methods: {
    // 统一初始化图表
    // 等待 DOM 更新完毕后再渲染
    initCharts() {
      this.$nextTick(() => {
        this.initLineChart()
        this.initPieChart()
      })
    },

    // 初始化折线图：近七日销售趋势
    initLineChart() {
      const myChart = echarts.init(document.getElementById('lineChart'))
      myChart.setOption({
        title: { text: '近七日销售趋势' },
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: ['1日','2日','3日','4日','5日','6日','7日']
        },
        yAxis: { type: 'value' },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'line',
          smooth: true
        }]
      })
    },

    // 初始化饼图：商品销量占比
    initPieChart() {
      const myChart = echarts.init(document.getElementById('pieChart'))
      myChart.setOption({
        title: { text: '商品销量占比' },
        tooltip: { trigger: 'item' },
        series: [{
          type: 'pie',
          radius: '60%',
          data: [
            { name:'手机', value:350 },
            { name:'电脑', value:220 },
            { name:'配件', value:180 },
            { name:'其他', value:100 }
          ]
        }]
      })
    },

    // 跳转到订单管理页面
    goOrder() {
      this.$router.push('/order')
    },

    // 跳转到用户管理页面
    goUser() {
      this.$router.push('/user')
    },

    // 跳转到商品管理页面
    goGoods() {
      this.$router.push('/goods')
    }
  }
}
</script>

<style scoped>
/* 卡片行底部间距 */
.card-row {
  margin-bottom: 10px;
}

/* 卡片容器，设置鼠标手势 */
.card-wrapper {
  cursor: pointer;
}

/* 统计卡片样式：居中 + 过渡动画 */
.stat-card {
  text-align: center;
  transition: all 0.3s;
}

/* 鼠标悬浮效果：上浮 + 阴影 */
.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

/* 标签文字样式 */
.label {
  font-size: 14px;
  color: #666;
}

/* 数字样式 */
.num {
  font-size: 22px;
  font-weight: bold;
  color: #409eff;
  margin-top: 10px;
}
</style>